module.exports = __webpack_public_path__ + "static/img/rotate08.f7e3c28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/horse/rotate08.png
// module id = Q1kJ
// module chunks = 1